import GLightbox from "glightbox";

export class MovieGLightbox {
	constructor(options) {
		this.version = "3.3.1"; // GLightbox version
		this.defaults = {
			url: ".", // url for the ajax call to retrieve the images
			per_page: 10, // used to determine the correct index for paginated images
			selector: null, // the selector for the click event listener (if null, skips the attachListener execution)
		};
		this.settings = Object.assign({}, this.defaults, options);
		this.instance = GLightbox({ selector: null });
		this.fetchPage();
	}

	fetchPage(page = 1) {
		const url = new URL(this.settings.url, window.location.origin);
		url.searchParams.append("page", page);
		fetch(url.toString(), {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (page === 1) {
					const images = [];
					data.forEach((image, index) => {
						images.push({ href: image.image, title: image.title });
					});
					this.instance.setElements(images);
				} else {
					data.forEach((image, index) => {
						this.instance.insertSlide({
							href: image.image,
							title: image.title,
						});
					});
				}
				if (this.settings.selector) {
					this.attachListener(page);
				} else {
					this.instance.open();
				}
			});
	}

	attachListener(page) {
		for (const el of document.querySelectorAll(this.settings.selector)) {
			const pageNum = Number.parseInt(el.dataset.galleryPage);
			if (pageNum === page) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					let index = Number.parseInt(el.dataset.galleryIndex);
					index += this.settings.per_page * (pageNum - 1);
					this.instance.openAt(index);
				});
			}
		}
	}
}

export class MovieFreeGLightbox {
	constructor(options) {
		this.version = "3.3.1"; // GLightbox version
		this.defaults = {
			selector: null, // the selector is also used for the click event listener (if null, skips the attachListener execution)
			elements: null,
		};
		this.settings = Object.assign({}, this.defaults, options);
		this.instance = GLightbox({
			selector: this.settings.selector,
			elements: this.settings.elements,
		});
		this.attachListener();
	}

	attachListener() {
		for (const el of document.querySelectorAll(this.settings.selector)) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				this.instance.openAt(el.dataset.galleryIndex);
			});
		}
	}
}

export class MovieVideoGLightbox {
	constructor(options) {
		this.version = "3.3.1"; // GLightbox version
		this.defaults = {
			selector: null, // the selector for the click event listener (if null, skips the attachListener execution)
			elements: null,
		};
		this.settings = Object.assign({}, this.defaults, options);
		this.instance = GLightbox({
			selector: this.settings.selector,
			elements: this.settings.elements,
		});
		this.attachListener();
	}

	attachListener() {
		for (const el of document.querySelectorAll(this.settings.selector)) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				const index = Number.parseInt(el.dataset.galleryIndex);
				this.instance.openAt(index);
			});
		}

		// loading JWplayer on slide load
		this.instance.on("slide_after_load", (data) => {
			const video = data.slideNode.querySelector("._glightbox_video");
			video.addEventListener("click", (event) => {
				event.preventDefault();
				const target = event.currentTarget;
				const video_container = target.parentNode;
				const video_title = target.querySelector("p").outerHTML;
				fetch(`/video/video-player/${target.dataset.id}`, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
				})
					.then((response) => response.text())
					.then((data) => {
						video_container.innerHTML = data;
						const video_player =
							video_container.querySelector("._player-video");
						const video_id = video_player.id;
						const jw_video_id = video_player.dataset.jw_video_id;
						const noads = video_player.dataset.noads;
						const autostart = video_player.dataset.autostart;
						import("./video_player.js").then((module) => {
							const MovieVideoPlayer = module.MovieVideoPlayer;
							const movieJWP = new MovieVideoPlayer();
							movieJWP.init().then((is_ready) => {
								if (!is_ready) {
									return;
								}
								const player = movieJWP.setupPlayer(
									video_id,
									jw_video_id,
									noads,
									autostart,
								);
								player.on("ready", (event) => {
									video_container
										.querySelector(`#${video_id}`)
										.insertAdjacentHTML("beforebegin", video_title);
								});
								player.play();
							});
						});
					})
					.catch((error) => {
						console.warn(error);
					});
			});
		});

		// pause JWplayer on slide change
		this.instance.on("slide_before_change", ({ prev, current }) => {
			const video = prev.slideNode.querySelector('[id^="video-"]');
			if (video) {
				const player = jwplayer(video.id);
				player.pause();
			}
		});
	}
}
